<template>
    <div class="text-xs h-full overflow-clip">
        <div class="flex flex-row justify-between border-b border-gray-300 py-1">
                <div class="pb-1.5">
                    Collections:
                </div>
                <div v-if="isLoading" role="status" class="pl-3">
                    <svg aria-hidden="true" class="mx-1 w-4 h-4 text-gray-200 animate-spin dark:text-gray-600"
                        viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="white"/>
                        <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="#2E9CCA"/>
                    </svg>
                    <span class="sr-only">Loading...</span>
                </div>
                <div v-else class="pl-3">
                    <svg @click="refetchCollections" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" stroke="#25274D" class="mx-1 w-4 h-4 hover:cursor-pointer">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
                            />
                    </svg>
                </div>
            </div>
            <!-- <BaseComboTable 
                :options="collectionOptions"
                v-model="filteredCollections"
                @update:model-value="setFilteredCollections">
            </BaseComboTable> -->
        <!-- <div class="py-2">
            <BaseComboBox
                :options="collectionOptions"
                v-model="filteredCollections"
                @update:model-value="setFilteredCollections"
            />
        </div> -->
        <div class="h-full overflow-y-scroll">
            <base-table-auto class="mb-8">
                <template #table-header>
                    <base-table-header
                        class="whitespace-nowrap"
                        :key="header.id"
                        :header="header"
                        v-for="header in tableHeadersList"
                    >
                    <span class="text-xs">{{ header }}</span>
                    </base-table-header>
                </template>
                <template #table-body>
                    <CollectionTableRow
                        v-for="collection in collections"
                        :key="collection.id"
                        :collection="collection"
                        :userId="userId"
                        @refetch-collections="refetchCollections"
                    />
                </template>
            </base-table-auto>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed} from 'vue';
import { useStore } from 'vuex';
import CollectionTableRow from './CollectionTableRow.vue';
import BaseComboBox from '../BaseComboBox.vue';
import BaseComboTable from '../BaseComboTable.vue';

const store = useStore()

const filteredCollections = ref([])

const props = defineProps([
    'userId',
    'collections',
    'isLoading'
])

const emit = defineEmits([
    'refetch-collection-tags'
])

const tableHeadersList = [
    'Name',
    '# Companies',
    'Created By',
    'Delete'
]

const collectionOptions = computed(() => {
    if(props.collections){
        return [{value: "clear", label: "------------"}, ...props.collections.map((collection) => {
            return {value: collection.id, label: collection.collection_tag_name}
        })]
    } else{
        return [{value: "clear", label: "------------"}]
    }

})

function setFilteredCollections(target) {
    if(target.includes("clear")){
        filteredCollections.value = []
    } else {
        filteredCollections.value = target;
    }
}

function refetchCollections () {
    emit('refetch-collection-tags')
}



</script>